import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation, Navigate } from 'react-router-dom'
import { Typography, Flex } from 'antd'
import { useAuthStore } from '@/app/store/authStore'
import { LoginForm } from '@/shared/ui/forms/LoginForm/LoginForm'
import { routes } from '@/shared/config/routes'
import { LoginCard, LoginContainer, LoginText, Logo } from './styled'
import { ErrorAlert } from '@/shared/ui/components/Alert'
import { ServerModal } from '@/shared/ui/components/ServerModal/ServerModal'

const { Title, Text } = Typography

export const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { login, isLoading, error, isAuthenticated, currentServer, setServer } =
    useAuthStore()

  const [isServerModalVisible, setIsServerModalVisible] = useState(false)
  const [selectedServer, setSelectedServer] = useState(currentServer)

  const DEFAULT_SERVER = 'https://hosting.glonasssoft.ru'

  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || routes.system
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, navigate, location])

  const handleLogin = async (credentials: {
    login: string
    password: string
  }) => {
    try {
      await login(credentials)
    } catch (error) {
      console.error('Login failed:', error)
    }
  }

  const handleServerButtonClick = () => {
    setSelectedServer(currentServer)
    setIsServerModalVisible(true)
  }

  const handleServerChange = (value: string) => {
    setSelectedServer(value)
  }

  const handleServerSave = () => {
    setServer(selectedServer)
    setIsServerModalVisible(false)
  }

  const handleServerModalCancel = () => {
    setSelectedServer(currentServer)
    setIsServerModalVisible(false)
  }

  const handleResetToDefault = () => {
    setSelectedServer(DEFAULT_SERVER)
  }

  const getCurrentServerLabel = () => {
    return currentServer || DEFAULT_SERVER
  }

  if (isAuthenticated) {
    return <Navigate to={routes.transfer} replace />
  }

  return (
    <>
      <LoginContainer>
        <LoginCard>
          <Flex vertical gap={48}>
            <Flex vertical gap={48}>
              <Logo src="/images/logo.svg" alt="ГлонассSoft Transfer" />
              <LoginText vertical>
                <Title style={{ textAlign: 'center' }} level={4}>
                  Вход в систему
                </Title>
                {error ? (
                  <ErrorAlert description={error} />
                ) : (
                  <Text
                    type="secondary"
                    style={{
                      maxWidth: '250px',
                      alignSelf: 'center',
                      textAlign: 'center',
                    }}
                  >
                    Введите данные от учетной записи куда необходимо переносить
                    данные
                  </Text>
                )}
              </LoginText>
            </Flex>
            <LoginForm
              onSubmit={handleLogin}
              isLoading={isLoading}
              error={error}
              onServerButtonClick={handleServerButtonClick}
              currentServer={getCurrentServerLabel()}
            />
          </Flex>
        </LoginCard>
      </LoginContainer>
      <ServerModal
        title="Подключение к внешнему серверу"
        open={isServerModalVisible}
        selectedServer={selectedServer}
        onSave={handleServerSave}
        onCancel={handleServerModalCancel}
        onChange={handleServerChange}
        onResetToDefault={handleResetToDefault}
        placeholder="Введите адрес сервера"
      />
    </>
  )
}
